import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth/guards/auth.guard';
import { Role } from './models/role.enum';
import { LayoutComponent } from './layout/layout.component';

const routes: Routes = [
  { path: '', redirectTo: 'timesheets', pathMatch: 'full' },
  {
    path: '',
    component: LayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule)
      },
      {
        path: 'timesheet/:year/:month',
        loadChildren: () => import('./timesheet-user/timesheet-user.module').then((m) => m.TimesheetUserModule),
        data: {
          allowedRoles: [Role.Admin, Role.User]
        }
      },
      {
        path: 'timesheet/:username/:year/:month',
        loadChildren: () => import('./timesheet-user/timesheet-user.module').then((m) => m.TimesheetUserModule),
        data: {
          allowedRoles: [Role.Admin]
        }
      },
      {
        path: 'timesheets',
        loadChildren: () => import('./timesheets-list/timesheets-list.module').then((m) => m.TimesheetsListModule),
        data: {
          allowedRoles: [Role.Admin]
        }
      },
      {
        path: 'employees',
        loadChildren: () => import('./employees/employees.module').then((m) => m.EmployeesModule),
        data: {
          allowedRoles: [Role.Admin]
        }
      },
      {
        path: 'monthly/:year/:month',
        loadChildren: () => import('./monthly-report/monthly-report.module').then((m) => m.MonthlyReportModule),
        data: {
          allowedRoles: [Role.Admin]
        }
      },
      {
        path: 'settings',
        loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule),
        data: {
          allowedRoles: [Role.Admin]
        }
      },
      {
        path: 'archive',
        loadChildren: () => import('./monthly-archive/monthly-archive.module').then((m) => m.MonthlyArchiveModule),
        data: {
          allowedRoles: [Role.Admin]
        }
      }
    ]
  },
  { path: '**', redirectTo: 'timesheets' }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
